import map from "lodash/map";
import get from "lodash/get";
import { checkNullable } from "../../../utilities/helpers";

const getShiftColumn = (shifts, templateType) => {
  return map(shifts, (shift, index) => {
    switch (templateType) {
      case 1:
        return {
          title: `${get(shift, "name")}`,
          children: [
            {
              title: "Machine",
              key: "machine",
              dataIndex: ["shifts", index, "machine"],
              render: (value) => (value ? value : "--"),
            },
            {
              title: "Count",
              key: "count",
              dataIndex: ["shifts", index, "counts"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Machine Efficiency",
              key: "machine_efficiency",
              dataIndex: ["shifts", index, "machine_efficiency"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Quality Ratio",
              key: "quality ratio",
              dataIndex: ["shifts", index, "quality_ratio"],
              render: (value) => (value ? value : 0),
            },
          ],
        };
      case 2:
        return {
          title: `${get(shift, "name")}`,
          children: [
            {
              title: "Machine",
              key: "machine",
              dataIndex: ["shifts", index, "machine"],
              render: (value) => (value ? value : "--"),
            },
            {
              title: "Length (in meter)",
              key: "length",
              dataIndex: ["shifts", index, "length"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Machine Efficiency",
              key: "machine_efficiency",
              dataIndex: ["shifts", index, "machine_efficiency"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Quality Ratio",
              key: "quality ratio",
              dataIndex: ["shifts", index, "quality_ratio"],
              render: (value) => (value ? value : 0),
            },
          ],
        };
      case 3:
        return {
          title: `${get(shift, "name")}`,
          children: [
            {
              title: "Machine",
              key: "machine",
              dataIndex: ["shifts", index, "machine"],
              render: (value) => (value ? value : "--"),
            },
            {
              title: "Count",
              key: "count",
              dataIndex: ["shifts", index, "count"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Machine Efficiency",
              key: "machine_efficiency",
              dataIndex: ["shifts", index, "machine_efficiency"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Quality Ratio",
              key: "quality ratio",
              dataIndex: ["shifts", index, "quality_ratio"],
              render: (value) => (value ? value : 0),
            },
          ],
        };
      case 4:
        return {
          title: `${get(shift, "name")}`,
          children: [
            {
              title: "Machine",
              key: "machine",
              dataIndex: ["shifts", index, "machine"],
              render: (value) => (value ? value : "--"),
            },
            {
              title: "Counts",
              key: "counts",
              dataIndex: ["shifts", index, "counts"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Machine Efficiency",
              key: "machine_efficiency",
              dataIndex: ["shifts", index, "machine_efficiency"],
              render: (value) => (value ? value : 0),
            },
            {
              title: "Quality Ratio",
              key: "quality ratio",
              dataIndex: ["shifts", index, "quality_ratio"],
              render: (value) => (value ? value : 0),
            },
          ],
        };
    }

  });
};

const getTotalColumn = (templateType) => {
  switch (templateType) {
    case 1:
      return {
        title: `Total`,
        fixed: "right",
        children: [
          {
            title: "Count",
            key: "count",
            dataIndex: ["summary", "counts"],
            fixed: "right",
          },
          {
            title: "Machine Efficiency",
            key: "machine_efficiency",
            dataIndex: ["summary", "machine_efficiency"],
            render: (value) => <>{checkNullable(value)}%</>,
            fixed: "right",
          },
          {
            title: "Quality Ratio",
            key: "quality_ratio",
            dataIndex: ["summary", "quality_ratio"],
            render: (value) => checkNullable(value),
            fixed: "right",
          },
        ],
      }
    case 2:
      return {
        title: `Total`,
        fixed: "right",
        children: [
          {
            title: "Length (in meter)",
            key: "length",
            dataIndex: ["summary", "length"],
            fixed: "right",
          },
          {
            title: "Machine Efficiency",
            key: "machine_efficiency",
            dataIndex: ["summary", "machine_efficiency"],
            render: (value) => <>{checkNullable(value)}%</>,
            fixed: "right",
          },
          {
            title: "Quality Ratio",
            key: "quality_ratio",
            dataIndex: ["summary", "quality_ratio"],
            render: (value) => checkNullable(value),
            fixed: "right",
          },
        ],
      }
    case 3:
      return {
        title: `Total`,
        fixed: "right",
        children: [
          {
            title: "Count",
            key: "count",
            dataIndex: ["summary", "count"],
            fixed: "right",
          },
          {
            title: "Machine Efficiency",
            key: "machine_efficiency",
            dataIndex: ["summary", "machine_efficiency"],
            render: (value) => <>{checkNullable(value)}%</>,
            fixed: "right",
          },
          {
            title: "Quality Ratio",
            key: "quality_ratio",
            dataIndex: ["summary", "quality_ratio"],
            render: (value) => checkNullable(value),
            fixed: "right",
          },
        ],
      }
    case 4:
      return {
        title: `Total`,
        fixed: "right",
        children: [
          {
            title: "Counts",
            key: "counts",
            dataIndex: ["summary", "counts"],
            fixed: "right",
          },
          {
            title: "Machine Efficiency",
            key: "machine_efficiency",
            dataIndex: ["summary", "machine_efficiency"],
            render: (value) => <>{checkNullable(value)}%</>,
            fixed: "right",
          },
          {
            title: "Quality Ratio",
            key: "quality_ratio",
            dataIndex: ["summary", "quality_ratio"],
            render: (value) => checkNullable(value),
            fixed: "right",
          },
        ],
      }
  }
}

export const getPartDetailColumns = (shifts, templateType) => {
  const shiftColumn = getShiftColumn(shifts, templateType);
  const totalColumn = getTotalColumn(templateType)
  return [
    {
      title: "Date",
      fixed: "left",
      dataIndex: "date",
    },
    ...shiftColumn,
    totalColumn,
  ];
};
